import md5 from 'md5-jkmyers';
import localStorage from './localStorage';

const LOCALSTORAGE_KEY = 'iono-uuid';

function createSeed () {
  // Get the network connection information
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var networkInfo = connection ? `${connection.effectiveType}${connection.downlink}${connection.rtt}`.replace(/\D+/g, '') : '';

  // Get the datetime information
  var currentDate = Date.now();

  // Get a random number between 1 and 100000
  var temprandomNumber = (Math.random() * 100000) + 1;
  var randomNumber = Math.round(temprandomNumber);

  // Add the datetime, network and random number together as string
  return networkInfo + currentDate + randomNumber;
}

export default function uuid () {
  try {
    let hash = localStorage.getItem(LOCALSTORAGE_KEY);

    // backwards compat: previously we used sha256, which generates pretty large hashes
    //  so here we check the size of the hash, if it's larger than 32 chars then we
    //  assume it was generated with the old sha256 method and so we need to re-create it
    if (hash && hash.length === 32) {
      return hash;
    }

    hash = md5(createSeed());
    localStorage.setItem(LOCALSTORAGE_KEY, hash);
    return hash;
  } catch (e) {}
}
